<template>
  <article class="appointment-wrapper">
    <group>
      <cell :title="`预约号：${detailInfo.id}`">
        <span slot="value" class="status_txt">{{detailInfo.status | formatStatus}}</span>
      </cell>
      <cell class="appointment_info">
      </cell>
      <cell class="appointment_info info_detail">
        <div slot="after-title" v-if="detailInfo.id">
          <p class="title_p"><span>预约分配：</span>{{detailInfo.appointed_time}} {{(detailInfo.receiver && detailInfo.receiver.name) || ''}}</p>
          <p class="title_p" v-if="['fulfilled', 'after_fulfilled', 'before_fulfilled'].includes(detailInfo.status)"><span>到店时间：</span>{{`${detailInfo.fulfilled_at}（${getArrivalStatus(detailInfo.status)}）`}}</p>
          <p class="title_p"><span>车牌号码：</span>{{detailInfo.plate_number || '--'}}</p>
          <p class="title_p"><span>车架号码：</span>{{detailInfo.vin || '--'}}</p>
          <p class="title_p"><span>车型：</span>{{detailInfo.car_model || '--'}}</p>
          <p class="title_p"><span>行驶里程：</span>{{detailInfo.mileage}} km</p>
          <p class="title_p"><span>客户姓名：</span>{{detailInfo.contact_name}}</p>
          <p class="title_p"><span>手机号码：</span><a class="phone" :href="`tel:${detailInfo.contact_number}`">{{detailInfo.contact_number}}</a></p>
          <p class="title_p"><span>服务项目：</span>{{detailInfo.services.map(item => item.name).join('、')}}</p>
          <p class="title_p"><span>跟进人：</span>{{detailInfo.service_consultant.name}}</p>
          <p class="title_p"><span>来源渠道：</span>{{detailInfo.channel.name}}</p>
          <!--<p class="title_p"><span>提交时间：</span>{{detailInfo.created_at}}</p>-->
          <p class="title_p db"><span>备注信息：</span><em class="fx1">{{detailInfo.remark || '--'}}</em></p>
          <p class="title_p"><span>其他标识：</span>{{detailInfo.other_mark || '--'}}</p>
          <p class="title_p db" v-if="detailInfo.status === 'unfulfilled'"><span>未到原因：</span><em class="fx1">{{detailInfo.reason || '--'}}</em></p>
        </div>
      </cell>
    </group>
    <section class="bottom-btns">
      <button
        v-for="btn in btns[detailInfo.support_ops]"
        :key="btn.text"
        @click="btn.operation"
      >{{ btn.text }}</button>
    </section>
    <!--取消预约弹窗-->
    <SendMsgPopup
      title="请输入取消原因"
      v-model="cancelVisible"
      :cb="cancelCb"
    />
    <!-- 已到店弹窗 -->
    <BizOptInStorePopup
      ref="bizOptInStorePopupRef"
      :changeStatus="changeStatus"
    />
  </article>
</template>
<script>
import { Group, Cell } from '@lx-frontend/cvux'
import SendMsgPopup from './SendMsgPopup'
import BizOptInStorePopup from './features/BizOptInStorePopup.vue'
import util from '../../common/util'

export default {
  components: {
    Group,
    Cell,
    SendMsgPopup,
    BizOptInStorePopup
  },
  data() {
    return {
      startDate: util.formatTime(new Date().valueOf() + 24 * 3600 * 1000, 'yyyy-MM-dd hh:mm'),
      changeTimeShow: false,
      oldTime: '',
      appointedTime: '',
      detailInfo: {
        service: {}
      },
      cancelVisible: false // 取消弹窗
    }
  },
  created() {
    this.initData()
    const change = {
      text: '更改预约',
      operation: this.doChange
    }
    const cancel = {
      text: '取消预约',
      operation: this.doCancel
    }
    const overTime = {
      text: '超时处理',
      operation: this.doOverTime
    }
    const inStore = {
      text: '已到店',
      operation: this.doInStore
    }
    const confirm = {
      text: '确认预约',
      operation: this.doConfirm
    }
    // const changeTime = {
    //   text: '更改预约时间',
    //   operation: this.doChangeTime
    // }
    this.btns = {
      finished: [],
      unconfirmed: [
        change,
        confirm
      ],
      unfulfilled: this.hasAuth('service_booking.modify_customer_enter_status') ? [
        inStore,
        change,
        cancel
      ] : [
        change,
        cancel
      ],
      unfulfilled_today: this.hasAuth('service_booking.modify_customer_enter_status') ? [inStore, change] : [change],
      unfulfilled_over_appointed: [ overTime ]
    }
    // this.renderBtns = [
    //   inStore,
    //   change,
    //   cancel,
    //   confirm,
    //   changeTime,
    //   overTime
    // ]
  },
  mounted() {
  },
  filters: {
    formatStatus(statusCode) {
      let statusTxt = {
        unknown: '未知',
        pending_fulfillment: '待到店',
        before_fulfilled: '已到店',
        fulfilled: '已到店',
        after_fulfilled: '已到店',
        canceled: '已取消',
        pending_confirm: '待确认',
        unfulfilled: '未到店'
      }
      return statusTxt[statusCode]
    }
  },
  computed: {
    showBtn() {
      return this.detailInfo.status === 'pending_fulfillment'
    },
    showTime() {
      return this.showBtn && this.detailInfo.is_confirmed
    }
  },
  methods: {
    hasAuth(auth) {
      return this.$store.state.promiseAuth.then(data => data.authList.includes(auth))
    },
    async cancelCb(msg) { // 取消回调
      await this.changeStatus({ action: 'cancel', reason: msg })
    },
    initData() {
      const id = this.$route.params.id
      this.$rest.appointment.getAppointmentDetailById(null, id).then((res) => {
        if (res.code === 0) {
          this.detailInfo = res.data
        } else {
          this.showToast(res.message)
        }
      })
    },
    getArrivalStatus(statusCode) {
      const statusTxt = {
        before_fulfilled: '提前到店',
        fulfilled: '准时到店',
        after_fulfilled: '超时到店'
      }
      return statusTxt[statusCode]
    },
    operate(status) {
      this.$rest.appointment.updateAppointmentStatus({
        action: status
      }, `${this.detailInfo.id}/status`).then((res) => {
        if (res.code === 0) {
          let data = res.data
          this.detailInfo.status = data.status
          this.detailInfo.is_confirmed = data.is_confirmed
        } else {
          this.showToast(res.message)
        }
      })
    },
    resetPopup() {
      this.cancelVisible = false
    },
    // 超时处理, 取消预约, 已到店, 确认预约 通用处理方法（还包括更改预约时间的操作）
    async changeStatus(params, api = 'updateAppointmentStatus') {
      this.loading = true
      try {
        const { code, message } = await this.$rest.appointment[api](this.detailInfo.id)(params)
        if (code === 0) {
          // this.detailInfo.status = data.status
          // this.detailInfo.support_ops = data.support_ops
          // this.detailInfo.is_confirmed = data.is_confirmed
          this.initData()
        }
        this.showToast(message)
        this.resetPopup()
      } catch (e) {
        this.showToast(e.message)
        throw e
      } finally {
        this.loading = false
      }
    },
    // showButton(text) {
    //   return this.btns[this.detailInfo.support_ops].some(item => item === text)
    // },
    // 更改预约
    doChange() {
      this.$router.push(`/appointment/updateOrder/${this.detailInfo.id}`)
    },
    doCancel() {
      this.cancelVisible = true
    },
    doOverTime() {
      const { id } = this.$route.params
      this.$router.push(`/appointment/OverTimeConfirm/${id}`)
    },
    doInStore() { // 已到店
      this.$refs.bizOptInStorePopupRef.open()
    },
    doConfirm() { // 确认预约
      this.changeStatus({ action: 'confirm' })
    },
    doChangeTime() { // 超时
      this.timeSettingVisible = true
    }
  }
}

</script>
<style lang="less">
@import "../../stylesheets/modules/appointment/detail.less";
</style>
